/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Actions for the container.
 */
import moment from 'moment';
import {
    FETCH_DATA,
    FETCH_COMPLETE,
    NOTIFY
} from './types';

import {
    users,
    despachos,
    customsHouses,
    customers,
    suppliers,
    preInvoice as preInvoiceService,
    statuses
} from '../../services';
import { COLORS } from '../../data/selects';


//Declare which services will use the container, to get catalogs etc
const services = {
    users,
    despachos,
    customsHouses,
    customers,
    suppliers,
    preInvoice:preInvoiceService,
    statuses
};

export const notify = (payload) => {
    return {
        type: NOTIFY,
        payload
    };
};
export const fetchUpdatedCustomClearenceArray = ( index, folioCustomClearence, params = {})  => {
    return services["despachos"].get('customsClearences', {...params, folio: folioCustomClearence}).then(data => {
        return data
      });
};

export const GuardarArchivosAdjuntos = (result, form) => {

  var form_data = new FormData();

  form_data.append("customsClearenceFolio",  result.folio);
  if(form.file != undefined || form.file != null){
    for(var i=0; i< form.file.length; i++){
      form_data.append("files", form.file[i]);
    }
  }


  return services["preInvoice"].post("preInvoice/attachments", form_data).then(result => {
      return result
  });
};

export const fetchData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(data => {
            if(typeof(data.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path, value: data._embedded.customsClearences },
                  { path: 'isLoading', value: false },
                  { path: 'numPages', value: data.page.totalPages },
                  { path: 'activePage', value: data.page.number }
              ]);
            }else{
              showErrorMessage(dispatch, data.response.data.message)
            }
        });
    };
};

export const fetchPreinvoice = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
          if(typeof(result.response) === "undefined"){
            onDataLoaded(dispatch, [
                { path, value: result._embedded.preInvoices },
                { path: 'isLoading', value: false }
            ]);
          }else{
            showErrorMessage(dispatch, result.response.data.message)
          }
        });
    };
};
export const fetchAttachedFiles = (service, path, url, params = {}) => {

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
          if(typeof(result.response) === "undefined"){
            onDataLoaded(dispatch, [
                { path, value: result },
                { path: 'isLoading', value: false }
            ]);
          }else{
            showErrorMessage(dispatch, result.response.data.message)
          }
        });
    };
};

export const fetchCustomer = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path, value: result._embedded.customers }
              ]);
            }else{
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const fetchSupplier = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path, value: result._embedded.suppliers }
              ]);
            }else{
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const fetchStatus = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path, value: result._embedded.clearenceStatuses }
              ]);
            }else{
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const fetchCustomsHousesForListing = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path: 'isLoading', value: false },
                  {
                      path,
                      value: {
                          items: result._embedded.customsHouses.map((customsHouse) => {
                              //TODO:
                              ///Aquí se repararía lo del UUID
                              return { id: customsHouse.name, name: customsHouse.name, uuid: customsHouse.id, ownOffice: customsHouse.ownOffice };
                          }),
                          displayProp: (item) => item.name
                      }
                  }
              ]);
            }else{
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const fetchCustomsHousesInLine = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path, value: result._embedded.customsHouses },
                  { path: 'isLoading', value: false }
              ]);
            }else{
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const fetchExecutiveUsersData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  {
                      path,
                      value: {
                          items: result._embedded.users.map((user) => {
                              return {
                                  id: '/users/' + user._links.self.href.substr(user._links.self.href.lastIndexOf('/') + 1),
                                  name: user.name
                              };
                          }),
                          displayProp: (item) => item.name
                      }
                  },
                  { path: 'isLoading', value: false }
              ]);
            }else{
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};


//FIXME Código duplicado en clase actions.js-clientes. ¿Qué se debe hacer?
//Conectar los dos actions en la clase index de despachos?
//Crear un componente React para añadir clientes y desplegarlos en un dropdown?
//Extraer este método a un helper? De ser así como extraigo el dispatch?
export const saveCustomer = (newCustomer) => {
    newCustomer = {
        ...newCustomer,
        address: {
            street: newCustomer.street,
            externalNumber: newCustomer.externalNumber,
            internalNumber: newCustomer.internalNumber,
            zipCode: newCustomer.zipCode,
            colony: newCustomer.colony,
            city: newCustomer.city,
            state: newCustomer.state,
            country: newCustomer.country,
            municipality: newCustomer.municipality
        }
    }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["customers"].post("customers?projection=denormalizedCustomer", newCustomer).then(result => {
            if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpenNewCustomer', value: false } });
            }else{
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpenNewCustomer', value: false } });
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};


//FIXME Código duplicado en clase actions.js-clientes. ¿Qué se debe hacer?
//Conectar los dos actions en la clase index de despachos?
//Crear un componente React para añadir proveedores y desplegarlos en un dropdown?
//Extraer este método a un helper? De ser así como extraigo el dispatch?
export const saveSupplier = (newSupplier) => {
    newSupplier = {
        ...newSupplier,
        address: {
            street: newSupplier.street,
            externalNumber: newSupplier.externalNumber,
            internalNumber: newSupplier.internalNumber,
            zipCode: newSupplier.zipCode,
            colony: newSupplier.colony,
            city: newSupplier.city,
            state: newSupplier.state,
            country: newSupplier.country,
            municipality: newSupplier.municipality
        }
    }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["suppliers"].post("suppliers?projection=denormalizedCustomer", newSupplier).then(result => {
            if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpenNewSupplier', value: false } });
            }else{
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpenNewSupplier', value: false } });
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const saveCustomsClearence = (form, userData) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services.despachos.get("clearenceStatuses/search/findByStatusName", { name: form.status }).then(result => {
            const newCustomsClearece = {
                ...form,
                status: result.statusName,
                statusColor: result.color,
                user:"id/"+userData.userId,
                customsHouse: "id/"+form.customsHouse,
                arrivalTimestamp: form.arrivalTimestamp === null ? "": moment(form.arrivalTimestamp).add(1, 'days').format('DD-MM-YYYY'),
                requestingPaymentTimestamp: form.requestingPaymentTimestamp === null ? "": moment(form.requestingPaymentTimestamp).add(1, 'days').format('DD-MM-YYYY')
            };

            return services.despachos.post("customsClearences?projection=customsClearenceInLine", newCustomsClearece).then(result => {

                if(typeof(result.response) === "undefined"){
                  dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
                  //Añado nuevo cliente a la lista del estado
                  dispatch({ type: FETCH_COMPLETE, payload: { op: 'add', path: 'customsClearences', value: result } });

                  GuardarArchivosAdjuntos(result, form);
                }else{
                  dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
                  showErrorMessage(dispatch, result.response.data.message)
                }

            });
        });
    };
};


const showErrorMessage = (dispatch, message)  => {

  onDataLoaded(dispatch, [
      { path: 'isLoading', value: false },
      { path: 'snackbarConfig>open', value: true },
      { path: 'snackbarConfig>message', value: message },
      { path: 'snackbarConfig>type', value: "red"}
  ]);
};

export const editCustomsClearence = (statuses, editedCustomsClearence, index) => {

    for(var i=0; i < statuses.length; i++)
    {
      if(statuses[i].statusName === editedCustomsClearence.status){
        editedCustomsClearence = {
          ...editedCustomsClearence,
          customsHouse: 'id/'+editedCustomsClearence.customsHouse.id,
          statusColor: statuses[i].color
        }
      }
    }

    console.log(editedCustomsClearence);

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });


        const injected = {
            ...editedCustomsClearence,
            user: editedCustomsClearence.user.id,
            arrivalTimestamp: editedCustomsClearence.arrivalTimestamp === null ? "": moment(editedCustomsClearence.arrivalTimestamp).add(1, 'days').format('DD-MM-YYYY'),
            requestingPaymentTimestamp: editedCustomsClearence.requestingPaymentTimestamp === null ? "": moment(editedCustomsClearence.requestingPaymentTimestamp).add(1, 'days').format('DD-MM-YYYY'),
            customer: editedCustomsClearence.customer.id,
            supplier: editedCustomsClearence.supplier.id
        }


        return services.despachos.patch("customsClearences/" + injected.id + "?projection=customsClearenceInLine", injected).then(result => {
          if(typeof(result.response) === "undefined"){
            //Añado nuevo cliente a la lista del estado
            dispatch({ type: FETCH_COMPLETE, payload: { op: 'updateItem', path: 'customsClearences', value: { index, value: {...result, id:injected.id } } }});

          }else{
            dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'modalInfoState>modalInfoOpen', value: false } });
            showErrorMessage(dispatch, result.response.data.message)
          }
        });
    };
};

export const fetchUpdatedCustomClearence = (service, index, idCustomclearence, folioCustomClearence, url, params = {})  => {
  return (dispatch) => {
      dispatch({ type: FETCH_DATA });
      return services[service].get(url, {...params, folio: folioCustomClearence}).then(data => {
        if(typeof(data.response) === "undefined"){
          dispatch({ type: FETCH_COMPLETE, payload: { op: 'updateItem', path: 'customsClearences', value: { index, value:  { ...data._embedded.customsClearences[0], id: idCustomclearence} } }});
        }else{
          showErrorMessage(dispatch, data.response.data.message)
        }
      });
  };
};

export const savePreInvoice = (preInvoiceData) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        preInvoiceService.save(preInvoiceData).then(preInvoiceCreated => {
            if(typeof(preInvoiceCreated.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path: 'preInvoiceCreated', value: preInvoiceCreated },
                  { path: 'isLoading', value: false }
              ]);
            }else{
              showErrorMessage(dispatch, preInvoiceCreated.response.data.message)
            }
        });
    };
};

export const DeletedAttachedFiles = (filesToRemove, folio) =>{

  var fileString = "";
  for (var i = 0; i < filesToRemove.length; i++) {
    if(i==0){
      fileString = fileString+filesToRemove[i];
    }else {
      fileString = fileString+","+filesToRemove[i];
    }
  }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
          services['preInvoice'].post('preInvoices/removeAttachments?customsClearenceFolio='+ folio+"&filesList="+fileString).then(result => {
          });
        };
};


const onDataLoaded = (dispatch, targets) => {
    dispatch({
        type: NOTIFY,
        payload: { op: 'multiUpdate', targets }
    });
};



// WEBPACK FOOTER //
// ./containers/despachos/actions.js